import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6nzzuc6eex: FaireBrandEntity = {
  token: "b_6nzzuc6eex",
  type: "brand",
  name: "Fine Diamond",
  avatarUrl:
    "https://cdn.faire.com/fastly/9d29cc504367c87d3e8a933c2017f8571da6f19ef7fc7e19564b14e31de1ce67.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1e039ad91af6a96868f49d567c9dd4daa60f4731c309e15b82319b18cd28c15d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9d29cc504367c87d3e8a933c2017f8571da6f19ef7fc7e19564b14e31de1ce67.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1e039ad91af6a96868f49d567c9dd4daa60f4731c309e15b82319b18cd28c15d.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 6,
  isTopShop: true,
  isInsider: true,
  description:
    "At Fine Diamond.Us we believe that every diamond tells a story — of love, legacy, and individuality. As a premier diamond jewelry company, we are dedicated to crafting pieces that celebrate life's most meaningful moments with timeless elegance and impeccable craftsmanship.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:58.531Z",
    importedBy: "entity-db-cli",
  },
};
